import { ApplyNewService } from '@/services/applyNew.service';
import { defineComponent, onMounted, onUnmounted } from 'vue';
import ApplyBanner from './components/ApplyBannerNew.vue';
import ApplyForm from './components/ApplyFormNew.vue';
import { useService, declareProviders } from '@kaokei/use-vue-service';
import { useRoute } from 'vue-router';
import { winTopPostMessage } from '@/utils/topWindowBridge';
export default defineComponent({
  name: 'ItemApply',
  components: {
    ApplyBanner: ApplyBanner,
    ApplyForm: ApplyForm
  },
  setup: function () {
    declareProviders([ApplyNewService]);
    var route = useRoute();
    var params = route.params;
    var itemId = +params.id;
    var applyService = useService(ApplyNewService);
    applyService.setItemId(itemId);
    var isEdit = route.query.userExamId ? 1 : 0;
    applyService.getContestInfo(isEdit);
    var msgCallback = function (ev) {
      var eventData = ev.data || {};
      if (eventData.method === 'fillB2CStudentInfo') {
        applyService.initB2CState(eventData.data);
      }
    };
    onMounted(function () {
      window.addEventListener('message', msgCallback);
      winTopPostMessage({
        method: 'getB2CClassRoomStudentInfo'
      });
    });
    onUnmounted(function () {
      window.removeEventListener('message', msgCallback);
    });
    return {
      applyService: applyService
    };
  }
});